import { render } from "./ModalEditLocations.vue?vue&type=template&id=3072b8e0&scoped=true"
import script from "./ModalEditLocations.vue?vue&type=script&lang=js"
export * from "./ModalEditLocations.vue?vue&type=script&lang=js"

import "./ModalEditLocations.vue?vue&type=style&index=0&id=3072b8e0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3072b8e0"]])

export default __exports__